import { toast } from "sonner";
import { translateServerError } from "@/lib/serverErrors";

/**
 * One place for user feedback after an action, so every form says the same kind of thing the same way:
 * a short title that names what happened ("Student updated") and an optional line of detail.
 * The <Toaster /> lives in main.tsx.
 */
export const notify = {
  success(title: string, description?: string) {
    return toast.success(title, { description, duration: 4000 });
  },
  error(title: string, description?: string) {
    return toast.error(title, { description, duration: 7000 });
  },
  warning(title: string, description?: string) {
    return toast.warning(title, { description, duration: 6000 });
  },
  info(title: string, description?: string) {
    return toast.info(title, { description, duration: 4000 });
  },
};

/** The best human-readable message inside whatever a failed request threw. */
export function errorMessage(err: unknown, fallback = "Something went wrong. Please try again."): string {
  const e = err as { response?: { data?: { error?: string; message?: string } }; message?: string } | undefined;
  return translateServerError(e?.response?.data?.error || e?.response?.data?.message || (e?.message && !/^Request failed/.test(e.message) ? e.message : "") || fallback);
}
